var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 206 67.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea75ad;}.cls-2{fill:#5d3233;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.71,36.28S137,66.42,99.29,67.62,27.48,43,27.48,43,59.39,1.23,97.14,0,166.71,36.28,166.71,36.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,61a94.77,94.77,0,0,1,10.8-8.63c3.79-2.64,7.71-5.11,11.75-7.37A165.21,165.21,0,0,1,47.89,33.4,169,169,0,0,1,103,23.49l7.07.09c2.35.09,4.7.27,7,.42s4.69.44,7,.73l3.51.44c.58.08,1.17.13,1.75.23l1.73.33L138.08,27c2.3.48,4.57,1.12,6.85,1.69l3.4.87,3.36,1.06c2.23.74,4.46,1.45,6.67,2.21A151.52,151.52,0,0,1,206,61c-2.16-.82-4.26-1.73-6.38-2.59L196.49,57l-1.56-.67-1.59-.6c-2.13-.79-4.22-1.62-6.32-2.44-1.06-.38-2.07-.87-3.14-1.21L180.69,51l-6.32-2.22L168,46.9l-3.18-1c-1.06-.3-2.14-.56-3.21-.84-2.15-.55-4.29-1.09-6.41-1.67a237.72,237.72,0,0,0-25.91-4.54c-2.16-.32-4.34-.42-6.51-.63s-4.35-.41-6.53-.45-4.36-.24-6.54-.29l-6.54,0A238.51,238.51,0,0,0,51,43.92c-8.62,2-17.18,4.46-25.67,7.3S8.39,57.25,0,61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset 3.1feb5087.svg";
export { ForwardRef as ReactComponent };